import React, { useRef, useEffect } from 'react';
import { registerBrick, File as OFile, Transaction, CloudObject } from 'olympe';
import { ReactBrick, getLogger } from '@olympeio/core';

/**
 * Provides a File Upload component using MUI
 */
export default class MobileFileUpload extends ReactBrick {
    /**
     * @override
     */
    setupExecution($) {
        return $.observe('Hidden');
    }

    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const [hidden] = props.values;

            /**
             * Ref of the upload text field used to open the file selector when triggering the
             * `Show File Selector` event
             * @type {React.MutableRefObject<null>}
             */
            const uploadTextField = useRef();

            useEffect(() => {
                $.observe('Show File Selector').subscribe(() => {
                    uploadTextField.current?.click();
                });
            }, []);

            if (hidden) {
                return null;
            }

            return (
                <input
                    ref={uploadTextField}
                    type='file'
                    accept='image/*'
                    capture={$.get('Capture') ? 'environment' : false}
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                    style={{ display: 'none' }}
                    onChange={(event) => {
                        MobileFileUpload.uploadFiles($, event.target.files);
                    }}
                />
            );
        };
    }

    /**
     * @static
     * @private
     * @param {!BrickContext} $
     * @param {!Array} files
     */
    static uploadFiles($, files) {
        // Local transaction
        const t = new Transaction();
        const file = files[0];

        // Read file content
        const reader = new FileReader();
        reader.onloadend = () => {
            // Find file model and create it locally
            const tag = t.create(OFile);
            OFile.setContent(t, tag, file.name, reader['result'], file.type);
            t.persist(tag, false);

            // Execute transaction
            t.execute()
                .then(() => {
                    $.set('File', CloudObject.get(tag));
                    $.trigger('On Change');
                })
                .catch((message) => getLogger('FileUpload').warn('The application encountered a problem while uploading files. The transaction failed.', message));
        };
        reader.readAsArrayBuffer(file);
    }
}

registerBrick('018afedcc93816473ccc', MobileFileUpload);
